export default {
  CLIENT_ID: "client_id",
  ADDRESS_TYPE: "addressType",
  ADDRESS_ID: "addressId",
  ADDRESS_TYPE_ID: "addressTypeId",
  IS_ACTIVE: "isActive",
  STREET: "street",
  ADDRESS_LINE1: "addressLine1",
  ADDRESS_LINE2: "addressLine2",
  ADDRESS_LINE3: "addressLine3",
  TOWN_VILLAGE: "townVillage",
  CITY: "city",
  COUNTY_DISTRICT: "countyDistrict",
  STATE_PROVINCE_ID: "stateProvinceId",
  COUNTRY_NAME: "countryName",
  STATE_NAME: "stateName",
  COUNTRY_ID: "countryId",
  POSTAL_CODE: "postalCode",
  LATITUDE: "latitude",
  LONGITUDE: "longitude",
  COUNTRY_ID_OPTIONS: "countryIdOptions",
  STATE_PROVINCE_ID_OPTIONS: "stateProvinceIdOptions",
  ADDRESS_TYPE_ID_OPTIONS: "addressTypeIdOptions",
  ADDRESS_OWNERSHIP_TYPE: "addressOwnershipTypeId",
  ADDRESS_OWNERSHIP_TYPE_OPTIONS: "addressOwnershipTypeIdOptions",
  YEAR_AT_ADDRESS: "yearsAtAddress",
  MONTH_AT_ADDRESS: "monthsAtAddress",
  LOCALE_STRING: "locale",
  LOCALE: "en_IN",
  OFFICE_OR_WORK_ADDRESS_TYPE : "office",
  PERMANENT_ADDRESS_TYPE : "permanent",
  HOME_ADDRESS_TYPE : "home",
  COMMUNICATION_ADDRESS_TYPE : "communication",
  MONTHLY_RENT : "monthlyRent",
  YEARS_AT_CITY : "yearsAtCity",
  MONTHS_AT_CITY : "monthsAtCity",



  getAddressPayload(address) {
    const addressPayload = {};
    addressPayload[this.IS_ACTIVE] = true;
    addressPayload[this.STREET] = address[this.STREET];
    addressPayload[this.ADDRESS_LINE1] = address[this.ADDRESS_LINE1];
    addressPayload[this.ADDRESS_LINE2] = address[this.ADDRESS_LINE2];
    addressPayload[this.ADDRESS_LINE3] = address[this.ADDRESS_LINE3];
    addressPayload[this.CITY] = address[this.CITY];
    addressPayload[this.POSTAL_CODE] = address[this.POSTAL_CODE];
    addressPayload[this.ADDRESS_TYPE_ID] = address[this.ADDRESS_TYPE_ID];
    addressPayload[this.STATE_PROVINCE_ID] = address[this.STATE_PROVINCE_ID];
    addressPayload[this.COUNTRY_ID] = address[this.COUNTRY_ID];
    addressPayload[this.ADDRESS_OWNERSHIP_TYPE] = address[this.ADDRESS_OWNERSHIP_TYPE];
    addressPayload[this.YEAR_AT_ADDRESS] = address[this.YEAR_AT_ADDRESS];
    addressPayload[this.MONTH_AT_ADDRESS] = address[this.MONTH_AT_ADDRESS];
    addressPayload[this.MONTHLY_RENT] = address[this.MONTHLY_RENT];
    addressPayload[this.YEARS_AT_CITY] = address[this.YEARS_AT_CITY];
    addressPayload[this.MONTHS_AT_CITY] = address[this.MONTHS_AT_CITY];
    addressPayload[this.LOCALE_STRING] = this.LOCALE;
    return addressPayload;
  }
}